import { useState } from "react";

// toast notifications
import { toast } from "react-toastify";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Data and functions
import { useUserContext } from "contexts/contextUser";
import { useDeleteUser } from "api/features/auth/queries";

function DeleteAccount(): JSX.Element {
  const { user, logout } = useUserContext();
  const deleteUserClient = useDeleteUser();

  const [deleting, setDeleting] = useState(false);

  const handleDeleteAccount = () => {
    setDeleting(true);
    deleteUserClient.mutate(
      {
        userId: user?.user_id,
      },
      {
        onSuccess: () => {
          toast.success("Account deleted successfully");
          setDeleting(false);
          logout();
        },
        onError: (error: any) => {
          toast.error(`Error deleting account: ${error.message}`);
          setDeleting(false);
        },
      }
    );
  };

  return (
    <Card id="delete-account">
      <MDBox
        pr={3}
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <MDBox p={3} lineHeight={1}>
          <MDBox mb={1}>
            <MDTypography variant="h5">Delete Account</MDTypography>
          </MDBox>
          <MDTypography variant="button" color="text">
            Once you delete your account, there is no going back. Please be certain.
          </MDTypography>
        </MDBox>
        <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
          <MDBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
            <MDButton
              variant="gradient"
              color="error"
              sx={{ height: "100%" }}
              disabled={deleting}
              onClick={handleDeleteAccount}
            >
              delete account
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default DeleteAccount;
